import { EMPTY, Subscription, catchError, finalize, from, switchMap, tap } from 'rxjs'
import { authState } from '../state/Auth.state'
import { horsesState } from '../state/Horses.state'
import { actualShowState } from '../state/ActualShow.state'
import { appState } from '../state/App.state'
import { resetRegistrationState } from '../components/pages/registration/Registration.state'
import { BookedService, Starter } from '../api'

export function initAppSubs(): Subscription[] {
  const subs: Subscription[] = []

  // user actions
  subs.push(
    authState.user$
      .pipe(
        switchMap((user) => {
          // reset state synchronously
          actualShowState.loading$.next(true)
          horsesState.horses$.next([])
          actualShowState.actualShow$.next(undefined)
          actualShowState.actualShowServices$.next([])
          actualShowState.actualShowExams$.next([])
          actualShowState.actualShowStarters$.next([])
          resetRegistrationState()

          // no user given -> end here
          if (!user || !user?.registerId) {
            actualShowState.loading$.next(false)
            return EMPTY
          }

          const actualShowId = (user.showId ?? (user as any).actualShow) ? parseInt(user.showId ?? (user as any).actualShow, 10) : null
          if (!actualShowId || isNaN(actualShowId)) {
            actualShowState.loading$.next(false)
            return EMPTY
          }
          actualShowState.actualShowNr$.next(actualShowId)

          const ownedHorses = (user as any)?.ownedHorses

          return from(
            Promise.all([
              horsesState.fetchHorses(ownedHorses),
              actualShowState.fetchShowForNr(actualShowId),
              actualShowState.fetchServicesForNr(actualShowId, user.registerId!),
              actualShowState.fetchExamsForNr(actualShowId, user.registerId!),
              actualShowState
                .fetchStartersForOwnerIdAndShow(user.registerId ?? '', actualShowId)
                .catch(() => [] as Starter[]),
              actualShowState
                .fetchBookedServicesForOwnerIdAndShow(user.registerId ?? '', actualShowId)
                .catch(() => [] as BookedService[])
            ])
          ).pipe(
            tap(([horses, actualShow, actualShowServices, actualShowExams, actualShowStarters, actualShowBookedServices]) => {
              horsesState.horses$.next(horses)
              actualShowState.actualShow$.next(actualShow)
              actualShowState.actualShowServices$.next(actualShowServices)
              actualShowState.actualShowExams$.next(actualShowExams)
              actualShowState.actualShowStarters$.next(actualShowStarters)
              actualShowState.actualShowBookedServices$.next(actualShowBookedServices as BookedService[])
            }),
            catchError((err: any) => {
              console.log(err)
              const status = err?.status ?? err?.response?.status
              if (status === 401 || status === 403) {
                authState.logout()
              } else {
                appState.addToast('Fehler beim Laden der Daten: ' + (err?.message ?? err), 'error')
              }
              return EMPTY
            }),
            finalize(() => {
              actualShowState.loading$.next(false)
            })
          )
        })
      )
      .subscribe()
  )

  return subs
}
